import {Component, OnInit} from '@angular/core';
import {ActivityEngineeringService} from '../../../data/activity-engineering.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Router} from '@angular/router';
import {EngineeringData} from '../../../data/engineering/engineering-data';
import {LocalStorage} from 'ngx-webstorage';

@Component({
  selector: 'app-activity-engineering',
  templateUrl: './activity-engineering.component.html',
  styleUrls: ['./activity-engineering.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityEngineeringComponent implements OnInit {
  constructor(
      public router: Router,
      protected engineeringService: ActivityEngineeringService,
      protected deviceService: DeviceDetectorService
  ) { }

  data: EngineeringData;
  deviceInfo: string;

  @LocalStorage()
  activeType: string;

  ngOnInit(): void {
    if (!this.activeType) {
      this.activeType = 'ENGINEERING';
    }
    this.loadColumns();
    this.detectDevice();
  }

  loadColumns() {
    this.engineeringService.getColumns(this.activeType).subscribe((data: EngineeringData) => {
      data.columns.forEach(column => {
        column.groups.forEach(group => {
          group.parent = column;
        });
      });
      this.data = data;
    });
  }

  setActiveType(type: string): void {
    this.activeType = type;
    this.loadColumns();
  }

  detectDevice() {
    if (this.deviceService.isMobile()) {
      this.deviceInfo = 'isMobile'
    }
    if (this.deviceService.isDesktop()) {
      this.deviceInfo = 'isDesktop'
    }
    if (this.deviceService.isTablet()) {
      this.deviceInfo = 'isTablet'
    }
  }

}
